// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"04bf05c1","89":"25504b2f","193":"41a41a0d","230":"a1cfcfba","241":"b9ca2dc7","284":"372d86e7","345":"3b6b9b09","414":"bc64de54","431":"5b067fb2","550":"f8896f2a","900":"0202f21b","918":"c5eff0a9","945":"7663a143","949":"5eeb37bc"}[chunkId] + ".chunk.js";
};